"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const FormInput_1 = require("../FormInput");
const FormFieldLayout_1 = require("../FormFieldLayout");
/**
 * Renders a collection of fields
 * @param fields
 * @returns {*}
 * @constructor
 */
const FieldInputs = ({ fields, layout = false }) => (React.createElement(FormFieldLayout_1.default, { layout: layout }, fields.map(f => (React.createElement(FormInput_1.default, { key: f._id, field: f })))));
// TODO - legacy support
exports.default = FieldInputs;
//# sourceMappingURL=index.js.map